import { ShippingPolicy } from '@/lib/types/shipping-policy';
import { atom } from 'jotai';

const defaultShippingPolicy: ShippingPolicy = {
  // Valeurs par défaut pour l'API
  freeShippingMinimumOrderAmount: null,
  deliveryOfferedNumberOfDays: null,
  pickupPointNetwork: null,
  basicFrPickupPointDeliveryPrice: null,

  // Valeurs par défaut pour l'UI
  minimumOrderEnabled: false,
  minimumOrderAmount: null,
  timeLimitedEnabled: false,
  offerDuration: null,
  pickupPointEnabled: false,
  pickupPointDeliveryPrice: null,
  allShippingFeesZero: false,
};

export const shippingPolicyState = atom<ShippingPolicy>(defaultShippingPolicy);
